/**
 * Smart Product Emails Theme JavaScript
 */

(function($) {
    'use strict';

    // DOM ready
    $(function() {
        // Initialize components
        initMobileMenu();
        initSmoothScroll();
        initAccessibility();
        initFeaturesShowcase();
        initTestimonialsCarousel();
        initGenericLightbox();
    });

    /**
     * Mobile Menu Toggle
     */
    function initMobileMenu() {
        const $menuToggle = $('.menu-toggle');
        const $menuContainer = $('.primary-menu-container');
        const $subMenuParents = $('#primary-menu .menu-item-has-children');
        const $body = $('body');

        // Toggle main mobile menu
        $menuToggle.on('click', function() {
            const $this = $(this);
            const isExpanded = $this.attr('aria-expanded') === 'true';

            $this.attr('aria-expanded', !isExpanded);
            $menuContainer.toggleClass('toggled');

            // Toggle body class to prevent scrolling when menu is open
            $body.toggleClass('mobile-menu-open');
        });

        // Handle submenu toggles on mobile
        $subMenuParents.each(function() {
            const $parent = $(this);
            const $link = $parent.children('a');

            // Add toggle button for mobile
            if (window.innerWidth < 1024) {
                const $toggle = $('<button class="submenu-toggle" aria-expanded="false"><span class="screen-reader-text">Toggle submenu</span></button>');
                $link.after($toggle);

                $toggle.on('click', function(e) {
                    e.preventDefault();
                    const isExpanded = $(this).attr('aria-expanded') === 'true';
                    $(this).attr('aria-expanded', !isExpanded);
                    $parent.toggleClass('toggled');
                });
            }
        });

        // Close menu on escape key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $menuContainer.hasClass('toggled')) {
                $menuToggle.attr('aria-expanded', 'false');
                $menuContainer.removeClass('toggled');
                $body.removeClass('mobile-menu-open');
                $menuToggle.focus();
            }
        });

        // Close menu when clicking outside
        $(document).on('click', function(e) {
            if ($menuContainer.hasClass('toggled') &&
                !$(e.target).closest('.main-navigation').length) {
                $menuToggle.attr('aria-expanded', 'false');
                $menuContainer.removeClass('toggled');
                $body.removeClass('mobile-menu-open');
            }
        });
    }

    /**
     * Smooth Scroll for anchor links
     */
    function initSmoothScroll() {
        $('a[href^="#"]').on('click', function(e) {
            const target = $(this.getAttribute('href'));

            if (target.length) {
                e.preventDefault();

                // Get the fixed header height plus some padding
                const headerHeight = $('.site-header').outerHeight() || 80;
                const offset = headerHeight + 20; // Header height + 20px padding

                $('html, body').animate({
                    scrollTop: target.offset().top - offset
                }, 500);

                // Set focus for accessibility
                target.attr('tabindex', '-1').focus();
            }
        });
    }

    /**
     * Accessibility Enhancements
     */
    function initAccessibility() {
        // Skip link focus fix for Chrome
        const skipLink = document.querySelector('.skip-link');

        if (skipLink) {
            skipLink.addEventListener('click', function(e) {
                const target = document.querySelector(this.getAttribute('href'));

                if (target) {
                    target.setAttribute('tabindex', '-1');
                    target.focus();
                }
            });
        }

        // Add focus class to parent menu items when child is focused
        $('#primary-menu a').on('focus blur', function() {
            $(this).parents('li').toggleClass('focus');
        });
    }

    /**
     * Features Showcase Carousel
     */
    function initFeaturesShowcase() {
        $('.spe-features-showcase').each(function() {
            const $showcase = $(this);
            const $textBlocks = $showcase.find('.spe-features-showcase__text-block');
            const $images = $showcase.find('.spe-features-showcase__image');
            const interval = parseInt($showcase.data('interval'), 10) || 5000;
            let currentIndex = 0;
            let intervalId = null;
            let isHovered = false;

            if ($textBlocks.length <= 1) {
                return;
            }

            function showFeature(index) {
                // Remove active/selected classes
                $textBlocks.removeClass('is-selected');
                $images.removeClass('is-active');

                // Add active/selected classes to current feature
                $textBlocks.eq(index).addClass('is-selected');
                $images.eq(index).addClass('is-active');

                // Update current index
                currentIndex = index;
            }

            function nextFeature() {
                const nextIndex = (currentIndex + 1) % $textBlocks.length;
                showFeature(nextIndex);
            }

            // Start auto-cycling
            function startCycle() {
                // Clear any existing interval first
                stopCycle();

                // Only start if not hovered
                if (!isHovered) {
                    intervalId = setInterval(nextFeature, interval);
                }
            }

            // Stop auto-cycling
            function stopCycle() {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
            }

            // Click handler for text blocks
            $textBlocks.on('click', function() {
                const clickedIndex = parseInt($(this).data('index'), 10);

                // Only reset if clicking a different item
                if (clickedIndex !== currentIndex) {
                    showFeature(clickedIndex);
                    startCycle();
                }
            });

            // Pause on hover
            $showcase.on('mouseenter', function() {
                isHovered = true;
                stopCycle();
            });

            $showcase.on('mouseleave', function() {
                isHovered = false;
                startCycle();
            });

            // Lightbox functionality for images
            $images.on('click', function(e) {
                // Only open lightbox if this image is active
                if ($(this).hasClass('is-active')) {
                    e.preventDefault();
                    e.stopPropagation();

                    const $img = $(this).find('img');
                    const imgSrc = $img.attr('src');
                    const imgAlt = $img.attr('alt') || 'Feature Image';

                    openLightbox(imgSrc, imgAlt);

                    return false;
                }
            });

            // Start the carousel
            startCycle();
        });
    }

    /**
     * Lightbox for Images
     */
    function openLightbox(imgSrc, imgAlt) {
        // Create lightbox if it doesn't exist
        if (!$('#spe-lightbox').length) {
            const lightboxHTML = `
                <div id="spe-lightbox" class="spe-lightbox">
                    <div class="spe-lightbox__backdrop"></div>
                    <div class="spe-lightbox__content">
                        <button class="spe-lightbox__close" aria-label="Close lightbox">×</button>
                        <img class="spe-lightbox__image" src="" alt="">
                    </div>
                </div>
            `;
            $('body').append(lightboxHTML);
        }

        const $lightbox = $('#spe-lightbox');
        const $lightboxImg = $lightbox.find('.spe-lightbox__image');

        // Set image source and alt text
        $lightboxImg.attr('src', imgSrc).attr('alt', imgAlt);

        // Save scroll position and lock body
        const scrollTop = $(window).scrollTop();
        $('body').css({
            'top': -scrollTop + 'px'
        }).addClass('spe-lightbox-open').data('scroll-position', scrollTop);

        // Show lightbox
        $lightbox.addClass('is-active');

        // Close handlers
        $lightbox.find('.spe-lightbox__close, .spe-lightbox__backdrop').off('click').on('click', function(e) {
            e.preventDefault();
            closeLightbox();
        });

        // Escape key handler
        $(document).off('keydown.lightbox').on('keydown.lightbox', function(e) {
            if (e.key === 'Escape') {
                closeLightbox();
            }
        });
    }

    function closeLightbox() {
        const $lightbox = $('#spe-lightbox');
        const $body = $('body');
        const $html = $('html');
        const scrollTop = $body.data('scroll-position') || 0;

        // Temporarily disable smooth scrolling
        $html.css('scroll-behavior', 'auto');

        // Hide lightbox
        $lightbox.removeClass('is-active');

        // Remove fixed positioning and restore scroll position instantly
        $body.removeClass('spe-lightbox-open').css('top', '');
        window.scrollTo(0, scrollTop);

        // Re-enable smooth scrolling after a short delay
        setTimeout(function() {
            $html.css('scroll-behavior', '');
        }, 50);

        // Remove escape key handler
        $(document).off('keydown.lightbox');
    }

    /**
     * Generic Lightbox for Images with 'lightbox' class
     */
    function initGenericLightbox() {
        // Handle images with 'lightbox' class
        $('.lightbox').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let imgSrc = '';
            let imgAlt = '';

            // Check if clicked element is an image
            if ($(this).is('img')) {
                imgSrc = $(this).attr('src');
                imgAlt = $(this).attr('alt') || 'Image';
            }
            // Check if clicked element is a link to an image
            else if ($(this).is('a')) {
                imgSrc = $(this).attr('href');
                const $img = $(this).find('img');
                if ($img.length) {
                    imgAlt = $img.attr('alt') || 'Image';
                } else {
                    imgAlt = $(this).attr('title') || 'Image';
                }
            }
            // Check if clicked element contains an image
            else {
                const $img = $(this).find('img');
                if ($img.length) {
                    imgSrc = $img.attr('src');
                    imgAlt = $img.attr('alt') || 'Image';
                }
            }

            if (imgSrc) {
                openLightbox(imgSrc, imgAlt);
            }

            return false;
        });
    }

    /**
     * Testimonials Carousel
     */
    function initTestimonialsCarousel() {
        $('.spe-testimonials-carousel').each(function() {
            const $carousel = $(this);
            const $slides = $carousel.find('.spe-testimonials-carousel__slide');
            const $dots = $carousel.find('.spe-testimonials-carousel__dot');
            const autoplay = $carousel.data('autoplay') === true || $carousel.data('autoplay') === 'true';
            const interval = parseInt($carousel.data('interval'), 10) || 5000;
            let currentIndex = 0;
            let intervalId = null;
            let isHovered = false;

            // No need to initialize if only one slide
            if ($slides.length <= 1) {
                return;
            }

            function showSlide(index) {
                // Remove active classes
                $slides.removeClass('is-active');
                $dots.removeClass('is-active');

                // Add active class to current slide and dot
                $slides.eq(index).addClass('is-active');
                $dots.eq(index).addClass('is-active');

                // Update current index
                currentIndex = index;
            }

            function nextSlide() {
                const nextIndex = (currentIndex + 1) % $slides.length;
                showSlide(nextIndex);
            }

            function prevSlide() {
                const prevIndex = (currentIndex - 1 + $slides.length) % $slides.length;
                showSlide(prevIndex);
            }

            // Start auto-cycling
            function startCycle() {
                // Clear any existing interval first
                stopCycle();

                // Only start if autoplay is enabled and not hovered
                if (autoplay && !isHovered) {
                    intervalId = setInterval(nextSlide, interval);
                }
            }

            // Stop auto-cycling
            function stopCycle() {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
            }

            // Click handler for dots
            $dots.on('click', function() {
                const clickedIndex = parseInt($(this).data('index'), 10);

                // Only reset if clicking a different dot
                if (clickedIndex !== currentIndex) {
                    showSlide(clickedIndex);
                    startCycle();
                }
            });

            // Pause on hover
            $carousel.on('mouseenter', function() {
                isHovered = true;
                stopCycle();
            });

            $carousel.on('mouseleave', function() {
                isHovered = false;
                startCycle();
            });

            // Keyboard navigation
            $carousel.on('keydown', function(e) {
                if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    prevSlide();
                    startCycle();
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    nextSlide();
                    startCycle();
                }
            });

            // Start the carousel if autoplay is enabled
            if (autoplay) {
                startCycle();
            }
        });
    }

})(jQuery);
